export default __webpack_public_path__ + "cfcc6506c2b9be0ab21f693311dcee0a.svg";